export default __webpack_public_path__ + "static/lc-b564e7a103c1601c67e2163f20ec8875.svg";